import * as angular from 'angular';
import { SpAlert } from '../../../../../../components/sp-alert/sp-alert.model';
import { countries } from '../../../../../../data/countries';

export class Controller {

    /** @ngInject */
    constructor(RegistrationProfile) {
        this.RegistrationProfile = RegistrationProfile;
    }

    $onInit() {
        this.countries = Object.keys(countries).map((code) => countries[code]);
        this.phoneNumbers = this.resolve.phoneNumbers;
        this.profile = angular.copy(this.resolve.profile);
    }

    save() {
        this.RegistrationProfile
            .updateProfile({id: this.profile.id}, this.profile).$promise
            .then((profile) => this.close({$value: profile}))
            .catch((response) => {
                this.spAlert = new SpAlert('danger', response.data.message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/extended/edit/edit.controller.js